<template>
  <div class="w-100">
    <h3 class="pageTitle">{{ pageTitle }}</h3>

    <div class="schedule-menu">
      <router-link :to="{name: 'BusTracker'}" class="schedule-menu__item">
        <div class="schedule-menu__icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <span>{{ getCaption("caption.bus_tracker") }}</span>
      </router-link>
      <router-link :to="{name: 'BusSchedule'}" class="schedule-menu__item">
        <div class="schedule-menu__icon">
          <i class="fas fa-bus"></i>
        </div>
        <span>{{ getCaption("caption.bus_schedule") }}</span>
      </router-link>
      <router-link :to="{name: 'AirSchedule'}" class="schedule-menu__item">
        <div class="schedule-menu__icon">
          <i class="fas fa-plane"></i>
        </div>
        <span>{{ getCaption("caption.air_schedule") }}</span>
      </router-link>
      <router-link :to="{name: 'TrainSchedule'}" class="schedule-menu__item">
        <div class="schedule-menu__icon">
          <i class="fas fa-subway"></i>
        </div>
        <span>{{ getCaption("caption.train_schedule") }}</span>
      </router-link>
      <router-link :to="{name: 'TrafficMap'}" class="schedule-menu__item">
        <div class="schedule-menu__icon">
          <i class="fas fa-traffic-light"></i>
        </div>
        <span>{{ getCaption("caption.traffic_map") }}</span>
      </router-link>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { transportationSchedule } from "@/constants/sidemenu.js";

export default {
  computed: {
    currentPath() {
      return this.$router.currentRoute.path;
    },

    pageTitle() {
      return this.$store.state.pageTitle;
    }
  },

  created() {
    this.$store.dispatch("setHasBreadcrumb", false);
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("setHasBreadcrumb", true);
    next();
  },

  mounted() {
    this.getPageTitle();
  },

  methods: {
    getPageTitle() {
      let pages = transportationSchedule.childEntries.rows;
      this.setStaticPageTitle(pages, this.currentPath);
    }
  }
};
</script>


<style lang="scss" scoped>
.schedule-menu {
  display: flex;
  flex-wrap: wrap;
  margin: 0.5em 0;
}

.schedule-menu__item {
  width: 100%;
  margin: 0.2em;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  display: flex;
  align-items: center;

  .schedule-menu__icon {
    width: 45px;
    padding: 0.3em 0.5em;
  }

  i {
    font-size: 2em;
  }
  p {
    margin: 0;
    font-size: 1.1em;
  }

  &.router-link-exact-active {
    background: linear-gradient(90deg, #840463 0%, #a03b11 100%);
    color: white;
    border: none;
  }
}

@media (min-width: $breakpoint-sm) {
  .schedule-menu__item {
    width: 45%;
  }
}

@media (min-width: $breakpoint-md) {
  .schedule-menu__item {
    width: 30%;
  }
}

@media (min-width: $breakpoint-xl) {
  .schedule-menu {
    display: none;
  }
}
</style>
